export const PT = () => {
  return (
    <>
      <g clipPath="url(#clip0_1073_11748)">
      <g clipPath="url(#clip1_1073_11748)">
      <rect x="32" width="96" height="32" transform="rotate(90 32 0)" fill="#00C17B"/>
      <rect x="96" width="96" height="64" transform="rotate(90 96 0)" fill="#EF4444"/>
      <circle cx="32" cy="48" r="16" fill="#EFD444"/>
      </g>
      </g>
      <rect x="2" y="2" width="92" height="92" rx="46" stroke="white" strokeOpacity="0.15" strokeWidth="4"/>
      <defs>
      <clipPath id="clip0_1073_11748">
      <rect width="96" height="96" rx="48" fill="white"/>
      </clipPath>
      <clipPath id="clip1_1073_11748">
      <rect width="96" height="96" rx="24" fill="white"/>
      </clipPath>
      </defs>
    </>
  )
}
